import GenericBody from "../Componentes/GenericBody";
import NavBar from "../Componentes/NavBar";
import { useModal } from "../contexts/ModalContext";
import ContentContainer from "../Modulos/Colaborador/ContentContainer";

const Colaborador = () => {

    const { openModal } = useModal();

    const openSideBar = () => {
        openModal('sidebarColaborador');
    }

    return(
        <>
            <NavBar title="COLABORADOR" setSideBar={ openSideBar } />
            <GenericBody>
                <ContentContainer />
            </GenericBody>
        </>
    )
}

export default Colaborador;